<script setup lang="ts">
/**
 * UI-kit component
 * Category: 'Menus'
 * Name: 'MenuSubItem'
 * FIGMA: ''
 */
import type { MenuSubItemProps } from '@UI/Menus/SidebarMenu/types/interfaces'

import { isLegacyLink } from '@helpers/legacy-marker'

import { AppText } from '@UI/Typography/AppText'

import MenuLegacyMarker from './MenuLegacyMarker.vue'

defineOptions({
  name: 'MenuSubItem',
})

const props = defineProps<MenuSubItemProps>()

const showLegacyMarker = computed<boolean>(() =>
  !props.isProduction && isLegacyLink({ isExternal: props.isExternal, neverMigrate: props.neverMigrate }),
)
</script>

<template>
  <NuxtLink
    :to="to"
    :external="isExternal"
    class="sub-menu__item"
    :class="{ 'is-active': active }"
  >
    <AppText
      name="body1"
      color="slate-300"
      class="sub-menu__item-text"
    >
      {{ text }}
    </AppText>
    <span
      v-if="showLegacyMarker"
      class="sub-menu__item-marker"
    >
      <MenuLegacyMarker />
    </span>
  </NuxtLink>
</template>

<style lang="scss" scoped src="../styles/_menu-sub-item.scss" />
